export default "/_next/static/chunks/fonts/GraphikLight-532fcbe7294b886ec93d51088382fb97.otf";